import { reactive, computed, onMounted, watch, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { POPUP, BTN, FEATURENAME } from '@/enum/enum';
import Select from '../../../components/ui/select/index.vue';
import Radio from '../../../components/ui/radio/index.vue';
import Checkbox from '../../../components/ui/checkbox/index.vue';
import Input from '../../../components/ui/input/index.vue';
import Button from '../../../components/ui/button/index.vue';
import DatePickerSingle from '@/components/ui/datePickerSingle/index.vue';
import { dateTimeHandle } from '@/utils/time';
import { apiGetCalibration, apiSetAppointments, apiSetModify, apiGetAPDeviceOrGroupID } from '@/api/api';
import { useI18n } from 'vue-i18n';
import * as moment from 'moment';
export default {
  components: {
    Select,
    Radio,
    Checkbox,
    Input,
    Button,
    DatePickerSingle
  },
  setup(props, { emit }) {//emit 傳到複層_emit('update:{function}', val)
    const { icon, isCheck } = props;
    const { t } = useI18n();
    //data
    let state = reactive({
      presetLimitList: [],
      date2: null,
      dateForbid2: null,
      date: "2022-01-01",
      dateForbid: '',
      calibrator: {
        text: 'Embedded Calibrator',
        val: 'Embedded Calibrator',
      },
      calibrator_op: [
        {
          text: 'Embedded Calibrator',
          val: 'Embedded Calibrator',
        },
        {
          text: 'Embedded Calibrator',
          val: 'Embedded Calibrator',
        },
      ],
      UTC: {
        text: 'UTC +14',
        val: '14',
      },
      UTC_op: [
        {
          text: 'UTC+14',
          val: '14',
        },
        {
          text: 'UTC+13',
          val: '13',
        },
        {
          text: 'UTC+12',
          val: '12',
        },
        {
          text: 'UTC+11',
          val: '11',
        },
        {
          text: 'UTC+10',
          val: '10',
        },
        {
          text: 'UTC+9',
          val: '9',
        },
        {
          text: 'UTC+8',
          val: '8',
        },
        {
          text: 'UTC+7',
          val: '7',
        },
        {
          text: 'UTC+6',
          val: '6',
        },
        {
          text: 'UTC+5',
          val: '5',
        },
        {
          text: 'UTC+4',
          val: '4',
        },
        {
          text: 'UTC+3',
          val: '3',
        },
        {
          text: 'UTC+2',
          val: '2',
        },
        {
          text: 'UTC+1',
          val: '1',
        },
        {
          text: 'UTC+0',
          val: '0',
        },
        {
          text: 'UTC-1',
          val: '-1',
        },
        {
          text: 'UTC-2',
          val: '-2',
        },
        {
          text: 'UTC-3',
          val: '-3',
        },
        {
          text: 'UTC-4',
          val: '-4',
        },
        {
          text: 'UTC-5',
          val: '-5',
        },
        {
          text: 'UTC-6',
          val: '-6',
        },
        {
          text: 'UTC-7',
          val: '-7',
        },
        {
          text: 'UTC-8',
          val: '-8',
        },
        {
          text: 'UTC-9',
          val: '-9',
        },
        {
          text: 'UTC-10',
          val: '-10',
        },
        {
          text: 'UTC-11',
          val: '-11',
        },
        {
          text: 'UTC-12',
          val: '-12',
        },
      ],
      hour: {
        text: "00",
        val: 0
      },
      hour_op: [],
      second: {
        text: "00",
        val: 0
      },
      second_op: [],
      week: {
        text: "",
        val: 0
      },
      week_op: [],
      day: {
        text: t('__common.__monday'),
        val: '1',
      },
      day_op: [
        {
          text: t('__common.__monday'),
          val: '1',
          isI18n: '__common.__monday',
        },
        {
          text: t('__common.__tuesday'),
          val: '2',
          isI18n: '__common.__tuesday',
        },
        {
          text: t('__common.__wednesday'),
          val: '3',
          isI18n: '__common.__wednesday',
        },
        {
          text: t('__common.__thursday'),
          val: '4',
          isI18n: '__common.__thursday',
        },
        {
          text: t('__common.__friday'),
          val: '5',
          isI18n: '__common.__friday',
        },
        {
          text: t('__common.__saturday'),
          val: '6',
          isI18n: '__common.__saturday',
        },
        {
          text: t('__common.__sunday'),
          val: '0',
          isI18n: '__common.__sunday',
        },
      ],
      month: {},
      month_op: [],
      rank: {},
      rank_op: [],
      selectedWarmUp: '0',
      selectedRepeat: '0',
      selectedAfter: '0',
      selectedReminder: '0',
      isCheck: true,
      work_day: false,
      isCheck_Array: [
        {
          text: "15",
          isCheck: false,
          val: 1,
          isI18n: '__common.__minutes',
        },
        {
          text: "30",
          isCheck: false,
          val: 2,
          isI18n: '__common.__minutes',
        },
        {
          text: "1",
          isCheck: false,
          val: 4,
          isI18n: '__common.__hour',
        },
        {
          text: "2",
          isCheck: false,
          val: 8,
          isI18n: '__common.__hours',
        },
        {
          text: "1",
          isCheck: false,
          val: 16,
          isI18n: '__common.__day',
        },
        {
          text: "2",
          isCheck: false,
          val: 32,
          isI18n: '__common.__days',
        },
      ],
      send: {},
      iscalibrator_embedded: false,
      showCalibratorEmbedded: false,
      model: "",
      data: {},
      APICalibrationData: {},
      target_op: [],
      target: {
        text: "",
        val: "",
      },
      EOTF_op: [],
      EOTF_op_default: [],
      EOTF: {
        text: "",
        val: "",
      },
      card: [],
      selectedVal: "0",
      gamut_disable: true,
      brightness_max_fix_right: 25,
      brightness_max_data: [300, 400, 500, 600, 700, 800, 900],
      brightness_max: 300,
      brightness_max_start: 300,
      brightness_max_max: true,
      brightness_max_min: false,
      brightness_max_step: 10,
      brightness_min_fix_right: 25,
      brightness_min_data: [300, 400, 500, 600, 700, 800, 900],
      brightness_min: 300,
      brightness_min_start: 300,
      brightness_min_dot: true,
      brightness_min_max: false,
      brightness_min_min: true,
      temperature_data: [4000, 5000, 6000, 7000, 8000, 9000],
      temperature: 0,
      temperature_max: false,
      temperature_min: false,
      temperature_lock: false,
      temperature_start: 4000,
      gamma_fix_right: 0,
      gamma_data: [],
      gamma_data_default: [1.6, 1.7, 1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, 2.8],
      gamma: 0,
      gamma_start: 0.8,
      gamma_dot: true,
      gamut: "",
      gamut_custom: null,
      color_standard: null,
      bright_max: 0,
      bright_min: 0,
      coordinateEnum: {},
      isstart: true,
      popup_data: {},
      forbid: '',
      // dayForbid:{
      //   date: '',
      //   utc : '',
      //   hour : '',
      //   min: '',
      // }
      dicomSelect_op: [], //color gamut選單
      dicomGamut: {},//color gamut選定
      applyDisable: false,
    })

    const iconSrc = computed(() => {
      if (icon === '') return '';
      return icon.indexOf('http') > -1 ? icon : require(`@/assets/images/${icon}`)
    })
    // Mounted
    const router = useRoute();
    const route = useRouter();
    onMounted(() => {
      if (router.name == "Modify Setting") {
        getAPIData();
      } else {
        state.send = storeState.calibrationPostData
        console.log('上一頁來的資料', state.send)
        if (!state.send["model"]) {
          route.push({ name: FEATURENAME.CALIBRATION });
        } else {
          getAPICalibrationData(state.send["model"])
        }
      }
      timeInit() //date
      console.log('onMounted ', state.send)
      timeZoneInit()
    })



    let isCheckArray = computed({
      get: () => {
        return [
          {
            text: "15" + t('__common.__minutes'),
            isCheck: false,
            val: 1,
          },
          {
            text: "30" + t('__common.__minutes'),
            isCheck: false,
            val: 2,
          },
          {
            text: "1" + t('__common.__hour'),
            isCheck: false,
            val: 4,
          },
          {
            text: "2" + t('__common.__hours'),
            isCheck: false,
            val: 8,
          },
          {
            text: "1" + t('__common.__day'),
            isCheck: false,
            val: 16,
          },
          {
            text: "2" + t('__common.__days'),
            isCheck: false,
            val: 32,
          },
        ]
      },
      set: () => {
      }
    })


    //上一頁又回來，放舊的資料
    const setSaveData = () => {
      console.log("34567890", storeState.advanceData.isCheck)
      // console.log("@#$@#$", isCheckArray.value)
      state.calibrator = storeState.advanceData.calibrator;
      state.iscalibrator_embedded = storeState.advanceData.embedded;
      state.selectedWarmUp = storeState.advanceData.warmUp;

      state.date2 = storeState.advanceData.date;
      state.UTC = storeState.advanceData.utc;
      state.hour = storeState.advanceData.hour;
      state.second = storeState.advanceData.second;
      state.selectedRepeat = storeState.advanceData.selectedRepeat;

      state.week = storeState.advanceData.week;
      state.day = storeState.advanceData.day;
      state.month = storeState.advanceData.month;
      state.rank = storeState.advanceData.rank;
      state.work_day = storeState.advanceData.workDay;
      state.selectedAfter = storeState.advanceData.selectedAfter;
      state.selectedReminder = storeState.advanceData.selectedReminder;
      state.isCheck_Array = storeState.advanceData.isCheck;
      console.log("@#$@#$", isCheckArray)

      store.commit('nextToAdvance', false);
      store.commit('setAdvanceData', {});

    }

    const timeZoneInit = () => {
      //測試 location  https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
      let location = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let timeZoneDefault = Intl.DateTimeFormat('fr', { timeZoneName: "short", timeZone: location, }).formatToParts().find((i) => i.type === "timeZoneName").value

      // 🔍 Debug: 顯示原始的時區字串格式
      console.log('🌍 [Timezone Debug] Original timeZoneDefault:', timeZoneDefault);
      console.log('🌍 [Timezone Debug] Browser location:', location);
      // console.log(new Intl.DateTimeFormat('en-GB', {timeZoneName: "short",timeZone: location, }).format(new Date()));

      // 修正：處理不同格式的時區字串（UTC、GMT、或其他格式）
      let timeZoneInitVal;
      if (timeZoneDefault.includes('UTC')) {
        timeZoneInitVal = timeZoneDefault.split('UTC')[1];
        console.log('🌍 [Timezone Debug] Parsed as UTC format, value:', timeZoneInitVal);
      } else if (timeZoneDefault.includes('GMT')) {
        timeZoneInitVal = timeZoneDefault.split('GMT')[1];
        console.log('🌍 [Timezone Debug] Parsed as GMT format, value:', timeZoneInitVal);
      } else {
        // 如果無法解析，使用 JavaScript 的 getTimezoneOffset 計算
        const offset = -new Date().getTimezoneOffset() / 60;
        timeZoneInitVal = offset >= 0 ? `+${offset}` : `${offset}`;
        timeZoneDefault = `UTC${timeZoneInitVal}`;
        console.log('🌍 [Timezone Debug] Unknown format, calculated from getTimezoneOffset():', timeZoneInitVal);
      }

      // 修正：處理 Unicode 減號 (U+2212) 轉換為 ASCII 減號
      // 某些瀏覽器/語言環境會使用 Unicode 減號 '−' 而不是 ASCII '-'
      if (timeZoneInitVal) {
        timeZoneInitVal = timeZoneInitVal.replace(/−/g, '-');  // 將 U+2212 替換為 ASCII '-'
        console.log('🌍 [Timezone Debug] After Unicode fix, value:', timeZoneInitVal);
      }

      console.log('🌍 [Timezone Debug] Final timeZoneInitVal:', timeZoneInitVal);
      // console.log(timeZoneDefault,location)

      state.UTC = {
        text: timeZoneDefault,
        val: timeZoneInitVal,
      }
      let hour = moment(new Date()).add({ hours: 0, minutes: 10 }).format('HH')
      // console.log(moment(new Date()).add({hours:2,minutes:30}).format('DD MM YYYY hh:mm:ss'))
      let hourVal = hour.indexOf('0') == 0 ? parseInt(hour.slice(1)) : parseInt(hour)
      // console.log(hour)
      state.hour = {
        text: hour,
        val: hourVal,
      }
      let min = moment(new Date()).add({ hours: 0, minutes: 10 }).format('mm')
      let minVal = min.indexOf('0') == 0 ? parseInt(min.slice(1)) : parseInt(min)
      // console.log(min)
      // console.log(minVal ,min, moment(new Date()).format('mm'))
      state.second = {
        text: min,
        val: minVal,
      }
      // console.log(new Intl.DateTimeFormat().formatToParts(date));

      // ✅ 新增：根據時區更新日期限制
      updateDateForbidByTimezone();
    }

    const timeInit = () => {
      if (state.selectedRepeat == '0') {
        setDateForbid()
      } else {

        //新的
        let sy = moment().format('YYYY')
        let sm = parseInt(moment().format('M'))
        let sd = moment().format('D')

        // 修正：使用明確的年月日建立 Date，避免時區轉換問題
        state.date2 = new Date(parseInt(sy), sm - 1, parseInt(sd));

        // let ss = `${sy}, ${sm}, ${sd}`
        // state.date2 = new Date(ss); //new Date(ss)是 obj
        // state.date2 = new Date(parseInt(sy), sm, parseInt(sd));


      }
    }

    const setDateForbid = () => {
      let now = new Date()

      console.log('📅 [Date Debug] setDateForbid - now:', now);
      console.log('📅 [Date Debug] setDateForbid - now.toString():', now.toString());

      let hour = moment(new Date()).add(2, 'hours').format('HH')
      let addDay = 0
      if (hour == '00' || hour == '01') { //晚上10點到11點，set time default 會是兩小時候，所以日期要加一天
        addDay = 1
      }
      now.setDate(now.getDate() + addDay);
      //old
      // let today = dateTimeHandle(now, 'YYYY-MM-DD', 'YYYY-MM-DD');
      // state.dateForbid = today;
      // state.date = today;
      //新的
      state.dateForbid2 = new Date(now.setHours(0, 0, 0, 0))
      let sy = moment().format('YYYY')
      let sm = parseInt(moment().format('M'))
      let sd = moment().format('D')

      console.log('📅 [Date Debug] sy:', sy, 'sm:', sm, 'sd:', sd);

      // 修正：使用明確的年月日建立 Date，避免時區轉換問題
      // new Date(year, monthIndex, day) 使用本地時區
      state.date2 = new Date(parseInt(sy), sm - 1, parseInt(sd));

      console.log('📅 [Date Debug] Final state.date2:', state.date2);
      console.log('📅 [Date Debug] Final state.date2.toString():', state.date2.toString());
    }

    // ✅ 新增：根據選擇的時區動態調整可選日期範圍
    const updateDateForbidByTimezone = () => {
      // 取得當前本地時間 + 10 分鐘（最小預約時間）
      let minTime = moment().add(10, 'minutes');

      // 取得選擇的時區偏移
      let chooseUTC = parseInt(state.UTC.val);
      if (isNaN(chooseUTC)) {
        chooseUTC = 0;  // 預設 UTC+0
      }

      // 修正：使用更簡單的方式計算目標時區的當天日期
      // 1. 取得 UTC 當前時間
      let nowUTC = moment.utc();

      // 2. 計算目標時區的當前時間（加上時區偏移的小時數）
      let targetTime = nowUTC.clone().add(chooseUTC, 'hours');

      // 3. 取得目標時區的年月日
      let targetYear = targetTime.year();
      let targetMonth = targetTime.month();
      let targetDate = targetTime.date();

      // 4. 在本地時區建立這個日期（設定為 00:00）
      let minDateLocal = moment().year(targetYear).month(targetMonth).date(targetDate).startOf('day');

      // console.log('📅 [Date Range] Selected timezone:', `UTC${chooseUTC >= 0 ? '+' : ''}${chooseUTC}`);
      // console.log('📅 [Date Range] Now UTC:', nowUTC.format('YYYY-MM-DD HH:mm Z'));
      // console.log('📅 [Date Range] Target timezone current time:', targetTime.format('YYYY-MM-DD HH:mm Z'));
      // console.log('📅 [Date Range] Target date (Y/M/D):', targetYear, targetMonth + 1, targetDate);
      // console.log('📅 [Date Range] Min selectable date (local TZ):', minDateLocal.format('YYYY-MM-DD HH:mm Z'));

      state.dateForbid2 = minDateLocal.toDate();
    }


    const changeDatePicker = (e) => {
      state.date2 = e;
    }

    const IsChecked = computed({
      get: () => isCheck,
      set: (val) => {
        emit('update:isCheck', val);
      }
    })
    const second_op = computed(() => {
      var _data = [];
      for (var a = 0; a < 60; a++) {
        var __data;
        if (a < 10) {
          __data = {
            text: '0' + a,
            val: a,
          }
        } else {
          __data = {
            text: a.toString(),
            val: a,
          }
        }
        _data.push(__data);
      }
      state.second_op = _data;
      return _data
    })
    const hour_op = computed(() => {
      var _data = [];
      for (var a = 0; a < 24; a++) {
        var __data;
        if (a < 10) {
          __data = {
            text: '0' + a,
            val: a,
          }
        } else {
          __data = {
            text: a.toString(),
            val: a,
          }
        }
        _data.push(__data);
      }

      state.hour_op = _data;
      console.log(state.hour_op)
      return _data
    })
    const week_op = computed(() => {
      var _data = [];
      for (var a = 1; a < 53; a++) {
        var _test = a == 1 ? t('__common.__week') : t('__common.__weeks');
        var __data = {
          text: a + ' ' + _test,
          val: a,
        }
        _data.push(__data);
      }
      state.week_op = _data;
      state.week = _data[0];
      return _data
    })
    const month_op = computed(() => {
      var _data = [];
      for (var a = 1; a < 13; a++) {
        var _test = a == 1 ? t('__common.__month') : t('__common.__months');
        var __data = {
          text: a + ' ' + _test,
          val: a,
        }
        _data.push(__data);
      }
      state.month_op = _data;
      state.month = _data[0];
      return _data
    })
    const rank_op = computed(() => {
      var _data = [];
      for (var a = 1; a < 32; a++) {
        var _test;
        if (a == 1 || a == 21 || a == 31) {
          _test = "st";
        } else if (a == 2 || a == 22) {
          _test = "nd"
        } else if (a == 3 || a == 23) {
          _test = "rd"
        } else if ((3 < a && a < 21) || (23 < a && a < 31)) {
          _test = "th"
        }
        var __data = {
          text: a + _test,
          val: a,
        }
        _data.push(__data);
      }
      state.rank_op = _data;
      state.rank = _data[0];
      return _data
    })


    const setLineBar = () => {
      console.log('setLineBar', state.selectedVal)
      // console.log('欸欸',state.card)
      //#region target EOTF
      state.brightness_max_start = 0;
      state.brightness_min_start = 0;
      state.temperature_start = 0;
      state.gamma_start = 0;
      state.selectedVal = state.data["mode"].toString();
      switch (state.selectedVal) {
        case "0":
          state.data["preset_target"].forEach(element => {
            var _click = state.card.map(x => x["id"]).indexOf(element);
            if (_click != -1) {
              state.card[_click]["click"] = true;
            }
          });

          var _target = state.target_op[0];
          state.gamut = _target["gamut"];
          var _eotf;
          if (_target["eotf"]) {
            for (var a = 0; a < state.EOTF_op_default.length; a++) {
              if (state.EOTF_op_default[a]["sub"]) {
                for (var b = 0; b < state.EOTF_op_default[a]["sub"].length; b++) {
                  if (_target["eotf"] == state.EOTF_op_default[a]["sub"][b].text) {
                    state.EOTF = state.EOTF_op_default[a]["sub"][b];
                    _eotf = state.EOTF_op_default[a]["sub"][b];
                  }
                }
              }
            }
          }
          if (_target["brightness"]) {
            state.brightness_max_start = _target["brightness"]
          } else {
            state.brightness_max_start = 0;
          }
          if (_target["brightness_min"]) {
            state.brightness_min_start = _target["brightness_min"]
          } else {
            state.brightness_min_start = 0;
          }
          if (_target["color_temperature"]) {
            // console.log('_target["color_temperature"]',_target["color_temperature"],state.temperature_start)
            state.temperature_start = _target["color_temperature"] / 100
          } else {
            state.temperature_start = 0;
          }
          // console.log(_target)
          if (_target["gamma"]) {
            state.gamma_start = _target["gamma"]
          } else {
            state.gamma_start = 0;
          }
          if (_eotf) {
            state.EOTF = _eotf;
          }
          break
        case "1":
        case "2":
          var _t = state.target_op.map(x => x.text).indexOf(state.data["user_target_name"]);
          if (_t != -1) {
            state.target = state.target_op[_t];
            _target = state.target_op[_t];
            state.gamut = _target["gamut"];
            _eotf;
            if (_target["eotf"]) {
              for (a = 0; a < state.EOTF_op_default.length; a++) {
                if (state.EOTF_op_default[a]["sub"]) {
                  for (b = 0; b < state.EOTF_op_default[a]["sub"].length; b++) {
                    if (_target["eotf"] == state.EOTF_op_default[a]["sub"][b].text) {
                      state.EOTF = state.EOTF_op_default[a]["sub"][b];
                      _eotf = state.EOTF_op_default[a]["sub"][b];
                    }
                  }
                }
                if (state.EOTF_op_default[a].text == _target["color_range"]) {
                  state.EOTF_op = state.EOTF_op_default[a]["sub"];
                }
              }
            }
            if (_target["brightness"]) {
              state.brightness_max_start = _target["brightness"]
            } else {
              state.brightness_max_start = 0;
            }
            if (_target["brightness_min"]) {
              state.brightness_min_start = _target["brightness_min"]
            } else {
              state.brightness_min_start = 0;
            }
            if (_target["color_temperature"]) {
              state.temperature_start = _target["color_temperature"] / 100
            } else {
              state.temperature_start = 0;
            }
            // console.log(_target)
            if (_target["gamma"]) {
              state.gamma_start = _target["gamma"]
            } else {
              state.gamma_start = 0;
            }
            if (_eotf) {
              state.EOTF = _eotf;
            }
          } else {
            ///有問題，Customized不應該寫死val，但他們說不是bug
            if (state.data["user_target_name"])
              state.target = {
                text: "Customized",
                val: "0",
              };
            ///有問題，Customized不應該寫死val，但他們說不是bug
            var _value = state.data["custom_settings"]
            // console.log("state.APICalibrationData", state.APICalibrationData)
            // console.log(_value);
            var _color_range;
            if (_value["color_range"] == 0) {
              _color_range = state.APICalibrationData["gamut"]["SDR"];
              state.EOTF_op = state.EOTF_op_default[0]["sub"];
            } else if (_value["color_range"] == 1) {
              _color_range = state.APICalibrationData["gamut"]["HDR"];
              state.EOTF_op = state.EOTF_op_default[1]["sub"];
            }
            var _key_color_range = Object.keys(_color_range);
            var _Object_color_range = Object.values(_color_range);
            for (var _k = 0; _k < _Object_color_range.length; _k++) {
              if (_value["gamut"] == _Object_color_range[_k]) {
                state.gamut = _key_color_range[_k];
              }
            }
            state.EOTF_op_default[0]["sub"].forEach(element => {
              if (_value["eotf"] == element.val) {
                state.EOTF = element;
              }
            });
            state.EOTF_op_default[1]["sub"].forEach(element => {
              if (_value["eotf"] == element.val) {
                state.EOTF = element;
              }
            });
            if (_value["brightness"]) {
              state.brightness_max_start = _value["brightness"];
            }
            if (_value["brightness_min"]) {
              state.brightness_min_start = _value["brightness_min"];
            }
            if (_value["color_temperature"]) {
              state.temperature_start = _value["color_temperature"] / 100;
            }
            if (_value["gamma"]) {
              state.gamma_start = _value["gamma"];
            }
          }
          break
      }
      //#endregion
      var _mode = "";//DICOM,HDR,SDR
      //#region 判斷_mode
      var _key;
      if (_mode == '' && state.EOTF.text == "DICOM") {
        _mode = "DICOM"
      }
      if (_mode == '' && state.APICalibrationData['eotf']['HDR']) {
        _key = Object.keys(state.APICalibrationData['eotf']['HDR'])
        for (var hdr = 0; hdr < _key.length; hdr++) {
          if (state.EOTF.text == _key[hdr]) {
            _mode = "HDR"
          }
        }
      }
      if (_mode == '' && state.APICalibrationData['eotf']['SDR']) {
        _key = Object.keys(state.APICalibrationData['eotf']['SDR'])
        for (var sdr = 0; sdr < _key.length; sdr++) {
          if (state.EOTF.text == _key[sdr]) {
            _mode = "SDR"
          }
        }
      }
      //#endregion
      console.log("_mode", _mode)
      if (_mode == "DICOM") {
        state.brightness_max_data = [];
        state.brightness_min_data = [];
        state.temperature_data = [];
        state.gamma_data = [];
        var _difference_max = (state.APICalibrationData['brightness']['DICOM']['brightness']['range_max'] - state.APICalibrationData['brightness']['DICOM']['brightness']['range_min']) / 6
        for (a = 0; a <= 6; a++) {
          var _math = 100;
          if (state.APICalibrationData['brightness']['DICOM']['brightness']['range_min'] / 100 < 1 || state.APICalibrationData['brightness']['DICOM']['brightness']['range_max'] - state.APICalibrationData['brightness']['DICOM']['brightness']['range_min'] < 100) {
            _math = 10
          }
          var _max = Math.round((state.APICalibrationData['brightness']['DICOM']['brightness']['range_min'] + _difference_max * a) / _math) * _math;
          state.brightness_max_data.push(_max)
        }
        state.brightness_min_data = state.APICalibrationData['brightness']['DICOM']['brightness_min']['range_values']
        state.brightness_max_data = state.brightness_max_data.filter(function (ele, pos) {
          return state.brightness_max_data.indexOf(ele) == pos;
        })
        state.brightness_max_max = state.APICalibrationData['brightness']['DICOM']['brightness']['max']
        state.brightness_max_min = state.APICalibrationData['brightness']['DICOM']['brightness']['min']
        state.brightness_min_max = state.APICalibrationData['brightness']['DICOM']['brightness_min']['max']
        state.brightness_min_min = state.APICalibrationData['brightness']['DICOM']['brightness_min']['min']
        state.brightness_max_step = state.APICalibrationData['brightness']['DICOM']['brightness']['step']
        state.bright_max = state.APICalibrationData['brightness_max']
        state.bright_min = state.APICalibrationData['brightness_min']
        if (state.brightness_max_start == 0) {
          state.brightness_max_start = state.brightness_max_data[0];
        } else if (state.brightness_max_start > state.brightness_max_data[state.brightness_max_data.length - 1] && !state.brightness_max_max) {
          state.brightness_max_start = state.brightness_max_data[state.brightness_max_data.length - 1];
        } else if (state.brightness_max_start > state.brightness_max_data[state.brightness_max_data.length - 1] && state.brightness_max_max && state.brightness_max_start != state.bright_max) {
          state.brightness_max_start = state.brightness_max_data[state.brightness_max_data.length - 1];
        }
        if (state.brightness_min_start == -1) {
          state.brightness_min_start = state.brightness_min_data[0];
        } else if (state.brightness_min_start != state.bright_min && state.brightness_min_min && state.brightness_min_start < state.brightness_min_data[0]) {
          state.brightness_min_start = state.brightness_min_data[0];
        } else if (!state.brightness_min_min && state.brightness_min_start < state.brightness_min_data[0]) {
          state.brightness_min_start = state.brightness_min_data[0];
        }
        // if (state.APICalibrationData['color_temperature']['SDR']['fix']) {
        //   state.temperature_lock = true;
        //   state.temperature_start = state.APICalibrationData['color_temperature']['SDR']['fix'] / 100
        //   _difference_max = (10000 - 4000) / 6
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.temperature_data.push(_max / 100)
        //   }
        //   state.temperature_data = state.temperature_data.filter(function (ele, pos) {
        //     return state.temperature_data.indexOf(ele) == pos;
        //   })
        // } else 
        if (state.APICalibrationData['color_temperature']['step']) {
          state.temperature_lock = false;
          _difference_max = (state.APICalibrationData['color_temperature']['range_max'] - state.APICalibrationData['color_temperature']['range_min']) / 6
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (state.APICalibrationData['color_temperature']['range_min'] / 100 < 1) {
              _math = 10
            }
            _max = Math.round((state.APICalibrationData['color_temperature']['range_min'] + _difference_max * a) / _math) * _math;
            state.temperature_data.push(_max / 100)
          }
          state.temperature_data = state.temperature_data.filter(function (ele, pos) {
            return state.temperature_data.indexOf(ele) == pos;
          })
          if (state.temperature_start == 0) {
            state.temperature_start = state.temperature_data[0];
          } else if (state.temperature_start > state.temperature_data[state.temperature_data.length - 1]) {
            state.temperature_start = state.temperature_data[state.temperature_data.length - 1]
          } else if (state.temperature_start < state.temperature_data[0]) {
            state.temperature_start = state.temperature_data[0]
          }
        }
      }
      if (_mode == "HDR") {
        state.brightness_max_data = [];
        state.brightness_min_data = [];
        state.temperature_data = [];
        state.gamma_data = [];
        _difference_max = (state.APICalibrationData['brightness']['HDR']['range_max'] - state.APICalibrationData['brightness']['HDR']['range_min']) / 6
        for (a = 0; a <= 6; a++) {
          _math = 100;
          if (state.APICalibrationData['brightness']['HDR']['range_min'] / 100 < 1) {
            _math = 10
          }
          _max = Math.round((state.APICalibrationData['brightness']['HDR']['range_min'] + _difference_max * a) / _math) * _math;
          state.brightness_max_data.push(_max)
        }
        state.brightness_max_data = state.brightness_max_data.filter(function (ele, pos) {
          return state.brightness_max_data.indexOf(ele) == pos;
        })
        state.bright_max = state.APICalibrationData['brightness_max']
        state.bright_min = state.APICalibrationData['brightness_min']
        if (state.brightness_max_start == 0) {
          state.brightness_max_start = state.brightness_max_data[0];
        }
        state.brightness_max_max = state.APICalibrationData['brightness']['HDR']['max']
        state.brightness_max_min = state.APICalibrationData['brightness']['HDR']['min']
        state.brightness_max_step = state.APICalibrationData['brightness']['HDR']['step']
        // if (state.APICalibrationData['color_temperature']['HDR']['fix']) {
        //   state.temperature_lock = true;
        //   state.temperature_start = state.APICalibrationData['color_temperature']['HDR']['fix'] / 100
        //   _difference_max = (10000 - 4000) / 6
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.temperature_data.push(_max / 100)
        //   }
        //   state.temperature_data = state.temperature_data.filter(function (ele, pos) {
        //     return state.temperature_data.indexOf(ele) == pos;
        //   })
        // } else 
        if (state.APICalibrationData['color_temperature']['step']) {
          state.temperature_lock = false;
          _difference_max = (state.APICalibrationData['color_temperature']['range_max'] - state.APICalibrationData['color_temperature']['range_min']) / 6
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (state.APICalibrationData['color_temperature']['range_min'] / 100 < 1) {
              _math = 10
            }
            _max = Math.round((state.APICalibrationData['color_temperature']['range_min'] + _difference_max * a) / _math) * _math;
            state.temperature_data.push(_max / 100)
          }
          state.temperature_data = state.temperature_data.filter(function (ele, pos) {
            return state.temperature_data.indexOf(ele) == pos;
          })
          if (state.temperature_start == 0) {
            state.temperature_start = state.temperature_data[0];
          }
        }
      }
      if (_mode == "SDR") {
        state.brightness_max_data = [];
        state.brightness_min_data = [];
        state.temperature_data = [];
        state.gamma_data = [];
        if (state.EOTF.text == "Gamma") {
          state.gamma_data = state.gamma_data_default;
          if (state.gamma_start == 0) {
            state.gamma = state.gamma_data[0];
          }
        }
        _difference_max = (state.APICalibrationData['brightness']['SDR']['range_max'] - state.APICalibrationData['brightness']['SDR']['range_min']) / 6
        for (a = 0; a <= 6; a++) {
          _math = 100;
          if (state.APICalibrationData['brightness']['SDR']['range_min'] / 100 < 1) {
            _math = 10
          }
          _max = Math.round((state.APICalibrationData['brightness']['SDR']['range_min'] + _difference_max * a) / _math) * _math;
          state.brightness_max_data.push(_max)
        }
        // state.brightness_max = state.brightness_max_data[0];
        state.brightness_max_data = state.brightness_max_data.filter(function (ele, pos) {
          return state.brightness_max_data.indexOf(ele) == pos;
        })
        if (state.brightness_max_start == 0) {
          state.brightness_max_start = state.brightness_max_data[0];
        }
        state.bright_max = state.APICalibrationData['brightness_max']
        state.bright_min = state.APICalibrationData['brightness_min']
        state.brightness_max_max = state.APICalibrationData['brightness']['SDR']['max']
        state.brightness_max_min = state.APICalibrationData['brightness']['SDR']['min']
        state.brightness_max_step = state.APICalibrationData['brightness']['SDR']['step']
        // if (state.APICalibrationData['color_temperature']['SDR']['fix']) {
        //   state.temperature_lock = true;
        //   state.temperature_start = state.APICalibrationData['color_temperature']['SDR']['fix'] / 100
        //   _difference_max = (10000 - 4000) / 6
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.temperature_data.push(_max / 100)
        //   }
        //   state.temperature_data = state.temperature_data.filter(function (ele, pos) {
        //     return state.temperature_data.indexOf(ele) == pos;
        //   })
        // } else 

        if (state.APICalibrationData['color_temperature']['step']) {
          state.temperature_lock = false;
          _difference_max = (state.APICalibrationData['color_temperature']['range_max'] - state.APICalibrationData['color_temperature']['range_min']) / 6
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (state.APICalibrationData['color_temperature']['range_min'] / 100 < 1) {
              _math = 10
            }
            _max = Math.round((state.APICalibrationData['color_temperature']['range_min'] + _difference_max * a) / _math) * _math;
            state.temperature_data.push(_max / 100)
          }
          state.temperature_data = state.temperature_data.filter(function (ele, pos) {
            return state.temperature_data.indexOf(ele) == pos;
          })
          if (state.temperature_start == 0) {
            state.temperature_start = state.temperature_data[0];
          }
        }
      }
      var _data = {
        selectedVal: state.selectedVal,
        APICalibrationData: state.APICalibrationData,
        target_op: state.target_op,
        target: state.target,
        gamut: state.gamut,
        EOTF_op_default: state.EOTF_op_default,
        EOTF_op: state.EOTF_op,
        EOTF: state.EOTF,
        card: state.card,
        gamut_disable: state.gamut_disable,
        brightness_max_fix_right: state.brightness_max_fix_right,
        brightness_max_data: state.brightness_max_data,
        brightness_max: state.brightness_max,
        brightness_max_start: state.brightness_max_start,
        brightness_max_max: state.brightness_max_max,
        brightness_max_min: state.brightness_max_min,
        brightness_max_step: state.brightness_max_step,
        brightness_min_fix_right: state.brightness_min_fix_right,
        brightness_min_data: state.brightness_min_data,
        brightness_min: state.brightness_min,
        brightness_min_start: state.brightness_min_start,
        brightness_min_dot: state.brightness_min_dot,
        brightness_min_max: state.brightness_min_max,
        brightness_min_min: state.brightness_min_min,
        temperature_data: state.temperature_data,
        temperature: state.temperature,
        temperature_max: state.temperature_max,
        temperature_min: state.temperature_min,
        temperature_lock: state.temperature_lock,
        temperature_start: state.temperature_start,
        gamma_fix_right: state.gamma_fix_right,
        gamma_data: state.gamma_data,
        gamma_data_default: state.gamma_data_default,
        gamma: state.gamma,
        gamma_start: state.gamma_start,
        gamma_dot: state.gamma_dot,
        bright_max: state.bright_max,
        bright_min: state.bright_max,
        dicomGamut: state.dicomGamut,
        dicomSelect_op: state.dicomSelect_op,
        coordinateEnum: state.coordinateEnum
      }
      state.popup_data = _data;
      console.log('ghfdkh', state.dicomGamut)
      console.log('popup_data', state.popup_data)
    }
    //#region API
    const getAPIData = async () => {
      try {
        // var device = route.currentRoute.value.params.device;
        // var type = route.currentRoute.value.params.type;
        //原本這三個參數是用來分device 或 group，然後取得清單再用預約id跑回圈找出是哪筆預約單號
        //現在直接使用預約id反查
        var id = route.currentRoute.value.params.id;
        var _data = null;
        var _device_data = null;



        const rawData = await apiGetAPDeviceOrGroupID(id);
        _data = rawData.data;
        _device_data = rawData.data;
        // console.log('基本資料',rawData.data)

        //#endregion
        if (_data != null && _device_data != null) {
          //#region set calibrator
          state.model = _device_data.model;
          state.data = _data;
          store.commit('setIsLoading', true); //資料會整理太久，導致使用者去點adjust parameters是空白的
          await getAPICalibrationData(_device_data.model) //query-settings取得設定

          for (let a = 0; a < state.calibrator_op.length; a++) {
            if (state.calibrator_op[a].val == _data.calibrator) {
              state.calibrator = state.calibrator_op[a]
            }
          }
          //#endregion
          //#region warm up 
          if (_data.warm_up) {
            state.selectedWarmUp = '0';
          } else {
            state.selectedWarmUp = '1'
          }
          //#endregion
          //#region time
          state.date2 = moment(_data.repeat_start_date).toDate()
          state.UTC = state.UTC_op[state.UTC_op.map(x => x.val).indexOf(_data.time_zone.toString())];
          state.hour = state.hour_op[state.hour_op.map(x => x.val).indexOf(_data.repeat_start_hour)];
          state.second = state.second_op[state.second_op.map(x => x.val).indexOf(_data.repeat_start_min)];
          //#endregion
          //#region repeat
          state.selectedRepeat = _data.repeat_type.toString();
          if (state.selectedRepeat == "1") {
            state.week = state.week_op[state.week_op.map(x => x.val).indexOf(_data.repeat_cycle)];
            state.day = state.day_op[state.day_op.map(x => x.val).indexOf(_data.repeat_period.toString())];
          } else if (state.selectedRepeat == "2") {
            state.month = state.month_op[state.month_op.map(x => x.val).indexOf(_data.repeat_cycle)];
            state.rank = state.rank_op[state.rank_op.map(x => x.val).indexOf(_data.repeat_period)];
            state.work_day = _data.repeat_postpone;
          }
          //#endregion
          //#region after
          state.selectedAfter = _data.post_action.toString();
          //#endregion

          //#region reminder
          let tempARR = state.isCheck_Array.map((e) => { return e.val })

          let result = 0
          result = result | _data.reminder_type;  // | 取最大 
          state.selectedReminder = _data.reminder_type ? "1" : "0"

          for (let i = 0; i < tempARR.length; i++) {
            if (result & tempARR[i]) { //二進位比對
              state.isCheck_Array[i].isCheck = true
            }
          }
          //#endregion
        }
        console.log('get state.data ', state.data)
        if (state.data["custom_settings"]) {

          state.popup_data["brightness_max"] = state.data["custom_settings"]['brightness']
          state.popup_data["brightness_min"] = state.data["custom_settings"]['brightness_min']
          state.popup_data["color_range"] = state.data["custom_settings"]['color_range']
          state.popup_data["old_color_range"] = state.data["custom_settings"]['color_range']

          state.popup_data["eotf"] = state.data["custom_settings"]['eotf'] //唯一modify模式preset mode 沒有的值，用來識別第一次進入modify
          state.popup_data["gamma"] = state.data["custom_settings"]['gamma']
          state.popup_data["gamut"] = state.data["custom_settings"]['gamut']

          // 暫存 gamut_custom 和 color_standard，稍後在 setLineBar() 之後處理
          if (state.data["custom_settings"]['gamut_custom'] !== undefined) {
            state.popup_data["gamut_custom"] = state.data["custom_settings"]['gamut_custom'];
          }
          if (state.data["custom_settings"]['color_standard'] !== undefined) {
            state.popup_data["color_standard"] = state.data["custom_settings"]['color_standard'];
          }



          //coordinate新流程
          let targetNow = state.popup_data['target_op'][state.popup_data['target_op'].map(x => x.val).indexOf(Number(state.popup_data['target'].val))];
          // console.log('???????????????', targetNow, state.data["custom_settings"]['color_temperature'])
          // console.log('???????????????', state.data["custom_settings"])
          // console.log('???????????????', state.popup_data["temperature"])
          state.popup_data["whitePointSelect"] = state.data["custom_settings"]['color_x'] ? 'coordinate' : 'colorTemperature'
          state.popup_data["whitePointDisable"] = state.data["custom_settings"]['color_x'] ? 1 : 2
          console.log('???????????????', state.popup_data["whitePointSelect"], state.popup_data["whitePointDisable"])


          if (state.data["custom_settings"]["color_x"] && state.data["custom_settings"]["color_y"]) {
            state.popup_data["coordinate"] = { x: state.data["custom_settings"]["color_x"].toString(), y: state.data["custom_settings"]["color_y"].toString() }
          } else {
            state.popup_data["coordinate"] = { x: state.coordinateEnum['x']['default'].toString(), y: state.coordinateEnum['y']['default'].toString() }
          }

          if (state.data["custom_settings"]['color_temperature']) {
            state.popup_data["temperature_start"] = state.data["custom_settings"]['color_temperature'] / 100
          } else {
            if (targetNow || targetNow == 0) {
              state.popup_data["temperature_start"] = targetNow['color_temperature'] / 100
            } else {//套用 cloud target 的模式的時候，temperature default 4000
              // state.popup_data["temperature_start"] = 40
            }
          }
          //coordinate新流程



          let tempGamut = Object.values(state.popup_data["APICalibrationData"]["gamut"]);
          tempGamut.forEach(element => {
            Object.keys(element).find((key) => {
              if (element[key] === state.data["custom_settings"]['gamut']) {
                state.popup_data["gamut"] = key
              }
            });
          });
          console.log('state.popup_data["gamut"]', state.popup_data)
          state.popup_data['showGamutSelect'] = state.popup_data["target"].val == 5 ? true : false; //gamut顯示選單是否切換成下拉選單
          // console.log('fdsgrgevr',state.popup_data['showGamutSelect'])
        } else {
          state.popup_data["whitePointSelect"] = 'colorTemperature'
          state.popup_data["whitePointDisable"] = 2
          state.popup_data["coordinate"] = { x: state.coordinateEnum['x']['default'].toString(), y: state.coordinateEnum['y']['default'].toString() }
          let targetNow = state.popup_data['target_op'][state.popup_data['target_op'].map(x => x.val).indexOf(Number(state.popup_data['target'].val))];

          for (let item of state.popup_data['EOTF_op_default']) {
            if (item["sub"]) {
              for (let b = 0; b < item["sub"].length; b++) {
                if (targetNow["eotf"] == item["sub"][b].text) {
                  state.popup_data['EOTF'] = item["sub"][b];
                  state.popup_data['color_range'] = item["sub"][b]['val']
                }
              }
            }
            if (item.text == targetNow["color_range"]) {
              state.popup_data['EOTF_op'] = item["sub"];
            }
          }
        }
        state.iscalibrator_embedded = _data.calibrator_embedded
        store.commit('setIsLoading', false);//資料會整理太久，導致使用者去點adjust parameters是空白的
      }
      catch (err) {
        console.log("apiGroupAppointment", 'err', err)
      }
    }
    const getAPICalibrationData = async (m) => {
      try {
        var _d = {
          model: m
        }
        const data = await apiGetCalibration(_d);
        console.log('Calibration data', data.data);
        //#region get calibrator
        state.presetLimitList = data.data.model.preset_modes.filter((e) => {
          return e.color_range == 'HDR'
        }).map((e) => {
          return e.id
        })
        // console.log('呱吉', state.presetLimitList);
        state.calibrator_op = [];
        for (var a = 0; a < data.data.calibrators.length; a++) {
          var _c = {
            text: data.data.calibrators[a].name,
            val: data.data.calibrators[a].id,
          }
          if (_c.text == "Embedded") {
            state.showCalibratorEmbedded = true;
          }
          state.calibrator_op.push(_c)
        }
        // sorting from a to z
        console.log('state.calibrator_op before sort', state.calibrator_op);
        if (state.calibrator_op.length) {
          state.calibrator_op.sort((a, b) => {
            if (a.text > b.text) {
              return 1;
            }
            if (a.text < b.text) {
              return -1;
            }
            return 0;
          });
        }
        console.log('after sorting', state.calibrator_op);
        state.calibrator = state.calibrator_op[0];
        //#endregion
        state.APICalibrationData = data.data;
        orgDicomOP()
        //#region set target
        var _model = data.data.model.user_modes;
        state.target_op = [];
        for (var _m = 0; _m < _model.length; _m++) {
          var _target = {
            text: _model[_m].name,
            val: _m,
            gamut: _model[_m].gamut,
            gamma: _model[_m].gamma,
            brightness: _model[_m].brightness,
            brightness_min: _model[_m].brightness_min,
            color_temperature: _model[_m].color_temperature,
            eotf: _model[_m].eotf,
            color_range: _model[_m].color_range,
            coordinate: data.data.color_xy,
          }
          state.target_op.push(_target);
        }
        _model = data.data.model.cloud_targets;
        for (_m = 0; _m < _model.length; _m++) {
          _target = {
            text: _model[_m].name,
            val: _model[_m].id,
            gamut: _model[_m].gamut,
            gamma: _model[_m].gamma,
            brightness: _model[_m].brightness,
            brightness_min: _model[_m].brightness_min,
            color_temperature: _model[_m].color_temperature,
            eotf: _model[_m].eotf,
            color_range: _model[_m].color_range,
            coordinate: data.data.color_xy,
          }
          state.target_op.push(_target);
        }
        state.target = {
          text: state.target_op[0].text,
          val: state.target_op[0].val,
        };
        state.gamut = state.target_op[0].gamut;
        //#endregion
        //#region EOTF
        state.EOTF_op_default = [];
        var _eotf = data.data.eotf;
        var _key_1 = Object.keys(_eotf);
        var _object_1 = Object.values(_eotf);
        var start = null;
        for (var _e = 0; _e < _key_1.length; _e++) {
          var _key_2 = Object.keys(_object_1[_e])
          var _object_2 = Object.values(_object_1[_e]);
          var _EOTF_op = {
            text: _key_1[_e],
            val: _key_1[_e],
            sub: []
          }
          for (var _e2 = 0; _e2 < _key_2.length; _e2++) {
            var _op = {
              text: _key_2[_e2],
              val: _object_2[_e2]
            }
            if (start == null) {
              start = _op;
            }
            _EOTF_op.sub.push(_op);
          }
          state.EOTF_op_default.push(_EOTF_op);
        }
        state.EOTF = start;
        //#endregion
        //#region card
        state.card = [];
        var _preset = data.data.model.preset_modes;
        for (var p = 0; p < _preset.length; p++) {
          var _card = {
            name: _preset[p].name,
            gamma: _preset[p].gamma,
            color: _preset[p].color_temperature,
            brightness: _preset[p].brightness,
            click: false,
            color_range: _preset[p].color_range,
            eotf: _preset[p].eotf,
            id: _preset[p].id,
          };
          state.card.push(_card);
        }

        for (const key in data.data.color_xy) {
          for (const k in data.data.color_xy[key]) {
            // console.log(key, k , data.data.color_xy[key][k])
            data.data.color_xy[key][k] = data.data.color_xy[key][k].toString()
          }
        }
        state.coordinateEnum = data.data.color_xy;
        //#endregion

        if (router.name == "Modify Setting") {
          setLineBar();

          // 在 setLineBar() 之後處理 dicomGamut（此時 state.dicomSelect_op 已初始化）
          if (state.data["custom_settings"] && state.data["custom_settings"]['gamut'] === 7) {
            if (state.data["custom_settings"]['gamut_custom'] !== undefined && state.dicomSelect_op && state.dicomSelect_op.length > 0) {
              let foundDicom = state.dicomSelect_op.find(item => item.val === state.data["custom_settings"]['gamut_custom']);
              if (foundDicom) {
                state.popup_data["dicomGamut"] = foundDicom;
              }
            }
          }
        }
        if (storeState.isNextToAdvance) { //回上一頁又回來
          setSaveData()
        }
      }
      catch (err) {
        console.log("apiGetCalibration", 'err')
      }
    }

    const orgDicomOP = async () => { //整理dicom 的下拉選單
      state.APICalibrationData['gamut'].SDR

      for (const key in state.APICalibrationData['gamut'].SDR) {
        state.dicomSelect_op.push({
          'text': key,
          'val': state.APICalibrationData['gamut'].SDR[key]
        })
      }
      state.dicomGamut = state.dicomSelect_op[0]
      // console.log('state.dicomSelect_op',state.dicomSelect_op)
    }



    const sendData = async () => {

      if (router.name != "Modify Setting") {
        console.log('send ~ 1', state.send)
        console.log('mode', state.send["mode"])
        // return
        state.send["repeat_type"] = parseInt(state.selectedRepeat);
        state.send["repeat_start_date"] = moment(state.date2).format('YYYY.MM.DD')
        state.send["repeat_start_hour"] = state.hour.val;
        state.send["repeat_start_min"] = state.second.val;
        const timeZone1 = parseInt(state.UTC.val);
        state.send["time_zone"] = isNaN(timeZone1) ? 0 : timeZone1;
        console.log('🚀 [API Debug] Sending time_zone:', state.send["time_zone"], '(parsed from:', state.UTC.val, ')');
        state.send["repeat_cycle"] = null;
        state.send["repeat_period"] = null;
        state.send["repeat_postpone"] = null;
        if (state.send["repeat_type"] == 1) {
          state.send["repeat_cycle"] = state.week.val;
          state.send["repeat_period"] = parseInt(state.day.val);
        } else if (state.send["repeat_type"] == 2) {
          state.send["repeat_cycle"] = state.month["val"];
          state.send["repeat_period"] = state.rank["val"];
          state.send["repeat_postpone"] = state.work_day;
        }
        state.send["calibrator"] = state.calibrator.val;
        state.send["calibrator_embedded"] = state.iscalibrator_embedded;
        // if (state.showCalibratorEmbedded && state.calibrator.text != "Embedded") {
        //   state.send["calibrator_embedded"] = state.iscalibrator_embedded;//暫定
        // }
        state.send["post_action"] = parseInt(state.selectedAfter);
        state.send["reminder_type"] = null;//0:不提醒,1:分鐘,2:小時,3:天
        // state.send["reminder_value"] = null;//時間常數


        if (state.send['color_temperature']) {
          state.send['color_temperature'] = state.send['color_temperature'] * 100
        }
        //coordinate
        if (state.send['coordinate']) {
          state.send['color_x'] = state.send['coordinate']['x']
          state.send['color_y'] = state.send['coordinate']['y']
          delete state.send["coordinate"];
        } else {
          state.send['color_x'] = null
          state.send['color_y'] = null
        }
        //coordinate

        //write
        let add = 0
        for (var a = 0; a < state.isCheck_Array.length; a++) {
          if (state.isCheck_Array[a].isCheck) {
            add += state.isCheck_Array[a].val
          }
        }
        state.send["reminder_type"] = add
        //write
        state.send["warm_up"] = false;
        if (state.selectedWarmUp == "0") {
          state.send["warm_up"] = true;
        }

        console.log('state.send apply', state.send)
        if (state.send["group_id"]?.length) {
          let temp = [...state.send["group_id"]]
          for (let i = 0; i < temp.length; i++) {
            state.send["group_id"] = temp[i]
            await apiSetAppointments(state.send);
          }
        } else {
          await apiSetAppointments(state.send);
        }



        state.applyDisable = false
        store.commit('setFlashMsg', { data: `${t('__flash.__appointmentSuccessfully')}`, isShow: true })
        route.push({ name: FEATURENAME.DASHBOARD });
      } else {
        store.commit('setGoApply', true)
        state.send = {
          id: state.data["id"],
          repeat_type: 0,                           //0，單次執行 1 周 2 月
          repeat_start_date: "",                    //Set Date Y.M.D
          repeat_start_hour: 0,                     //時
          repeat_start_min: 0,                      //分
          time_zone: 0,                             //時區
          repeat_cycle: null,                       //Every的選項  每隔多久repeat 此處因 repeat_type為0 單次執行 固無此設定
          repeat_period: null,                      //周級別  0~6 ，周日~周6  若為月級別的話則是1~31
          repeat_postpone: false,                   //是否只在工作天執行 月級別有可能為true
          calibrator: 0,                            //校色器選項 可透過5-1 取得model api得知
          calibrator_embedded: state.iscalibrator_embedded,               //若為內建校色器機種，選用外部校色器，才會需要必填
          post_action: 0,                           //校正完成後動作  0 不動作 1關機 2休眠
          reminder_type: 0,                         //事前提醒類型 0 不額外設定提醒 1 分鐘2小時 3天
          // reminder_value: 0,                        //事前提醒單位 以本例而言reminder type為1  reminder value為15則為15分前提醒
          mode: parseInt(state.data["mode"]),       //0 preset mode, 1 usermode1, 2 usermode2
          user_target_name: null,                   //target名稱 非presetmode時必填，但可以為空
          preset_target: [],                        //mode為0時, 才會必填
          color_range: 0,                           //必填 0 SDR, 1 HDR, 2 HDR_SDR  2的情況為preset mode且sdr hdr混合時
          gamut: null,
          gamut_custom: null,                             // 0 SRGB, 1 ADOBE_RGB, 2 REC_709, 3 DCI_P3,4 BT_2020_REC_2020
          eotf: null,                               // 0 SRGB, 1 GAMMA, 2 DICOM, 3 PQ, 4 HLG
          brightness: null,                         //若非preset mode 必填   但可為空 
          brightness_min: null,                     //eotf若為DICOM mode必填
          color_temperature: null,                  //若非preset mode 必填 色溫  必填但可為空
          gamma: null,
          color_standard: null,                              //若非preset mode 必填 gamma  必填但可為空 
          warm_up: false,                           //是否暖機，必填
          color_x: null,                               //色溫座標
          color_y: null,                               //色溫座標
        }
        //#region modify
        state.send["repeat_type"] = parseInt(state.selectedRepeat);
        state.send["repeat_start_date"] = moment(state.date2).format('YYYY.MM.DD')
        state.send["repeat_start_hour"] = state.hour.val;
        state.send["repeat_start_min"] = state.second.val;
        const timeZone2 = parseInt(state.UTC.val);
        state.send["time_zone"] = isNaN(timeZone2) ? 0 : timeZone2;
        console.log('🚀 [API Debug] Sending time_zone:', state.send["time_zone"], '(parsed from:', state.UTC.val, ')');
        if (state.send["repeat_type"] == 1) {
          state.send["repeat_cycle"] = state.week.val;
          state.send["repeat_period"] = parseInt(state.day.val);
        } else if (state.send["repeat_type"] == 2) {
          state.send["repeat_cycle"] = state.month["val"];
          state.send["repeat_period"] = state.rank["val"];
          state.send["repeat_postpone"] = state.work_day;
        }
        state.send["calibrator"] = state.calibrator.val;
        state.send["calibrator_embedded"] = state.iscalibrator_embedded;//暫定
        // if (state.showCalibratorEmbedded && state.calibrator.text != "Embedded") {
        //   state.send["calibrator_embedded"] = state.iscalibrator_embedded;//暫定
        // }
        state.send["post_action"] = parseInt(state.selectedAfter);
        state.send["reminder_type"] = null;//0:不提醒,1:分鐘,2:小時,3:天
        // state.send["reminder_value"] = null;//時間常數

        //write
        let add = 0
        for (var i = 0; i < state.isCheck_Array.length; i++) {
          if (state.isCheck_Array[i].isCheck) {
            add += state.isCheck_Array[i].val
          }
        }
        state.send["reminder_type"] = add
        //write

        state.send["warm_up"] = false;
        if (state.selectedWarmUp == "0") {
          state.send["warm_up"] = true;
        }
        //#endregion
        //#region calibration

        console.log('modify mode', state.popup_data)
        console.log('modify mode', typeof state.popup_data["card"])
        let _target;
        switch (state.send["mode"]) {
          case 0:
            var _color_range = "";
            if (state.popup_data["card"] && state.popup_data["card"].length > 0) {
              for (a = 0; a < state.popup_data["card"].length; a++) {
                if (state.popup_data["card"][a].click) {
                  state.send["preset_target"].push(state.popup_data["card"][a].id);
                  if (_color_range == "") {
                    _color_range = state.popup_data["card"][a]["color_range"]
                  } else if (_color_range != state.popup_data["card"][a]["color_range"]) {
                    _color_range = "HDR_SDR"
                  }
                }
              }
            } else if (state.data["preset_target"]) {
              // 如果 popup_data 沒有設定，使用原始資料
              state.send["preset_target"] = state.data["preset_target"];
            }
            if (_color_range == "SDR") {
              state.send["color_range"] = 0;
            } else if (_color_range == "HDR") {
              state.send["color_range"] = 1;
            } if (_color_range == "HDR_SDR") {
              state.send["color_range"] = 2;
            }
            break;
          case 1:
          case 2:
          case 3:
            // brightness 優先使用 popup_data，否則使用原始資料
            if (state.popup_data["brightness_max"]) {
              state.send["brightness"] = state.popup_data["brightness_max"];
            } else if (state.data["custom_settings"] && state.data["custom_settings"]['brightness']) {
              state.send["brightness"] = state.data["custom_settings"]['brightness'];
            }
            state.send["user_target_name"] = state.data["user_target_name"]; //直接使用原始資料
            console.log('target!!!', state.data["user_target_name"],)



            _target;
            _target = state.popup_data["target"] || state.target

            // console.log('target_op',state.popup_data["target_op"])
            // console.log('_target222222',_target)
            if (_target && _target.color_range == "SDR") {
              state.send["color_range"] = 0
            } else if (_target && _target.color_range == "HDR") {
              state.send["color_range"] = 1
            } else if (state.data["custom_settings"] && state.data["custom_settings"]["color_range"] !== undefined) {
              // 如果 target 沒有設定，使用原始資料
              state.send["color_range"] = state.data["custom_settings"]["color_range"];
            }
            console.log('state.send["gamut"]', state.popup_data["gamut"])
            if (state.popup_data["APICalibrationData"] && state.popup_data["APICalibrationData"]["gamut"]) {
              var _value = Object.values(state.popup_data["APICalibrationData"]["gamut"]);
              _value.forEach(element => {
                var _key = Object.keys(element);
                var _val = Object.values(element);
                for (var a = 0; a < _key.length; a++) {
                  if (_key[a] == state.popup_data["gamut"]) {
                    state.send["gamut"] = _val[a];
                  }
                }
              });
            } else if (state.data["custom_settings"] && state.data["custom_settings"]["gamut"] !== undefined) {
              // 如果 popup_data 沒有設定，使用原始資料
              state.send["gamut"] = state.data["custom_settings"]["gamut"];
            }
            console.log(' state.send["gamut"]', state.send["gamut"])

            // 當 gamut 為 7 時，需要帶入 gamut_custom 和 color_standard
            if (state.send["gamut"] === 7) {
              if (state.popup_data["dicomGamut"] && state.popup_data["dicomGamut"]["val"] !== undefined) {
                state.send["gamut_custom"] = state.popup_data["dicomGamut"]["val"];
              } else if (state.data["custom_settings"] && state.data["custom_settings"]["gamut_custom"] !== undefined) {
                state.send["gamut_custom"] = state.data["custom_settings"]["gamut_custom"];
              }

              if (state.data["custom_settings"] && state.data["custom_settings"]["color_standard"] !== undefined) {
                state.send["color_standard"] = state.data["custom_settings"]["color_standard"];
              }
            }
            if (state.popup_data["brightness_min_data"] && state.popup_data["brightness_min_data"].length > 0) {
              state.send["brightness_min"] = state.popup_data["brightness_min"];
            } else if (state.data["custom_settings"] && state.data["custom_settings"]["brightness_min"]) {
              state.send["brightness_min"] = state.data["custom_settings"]["brightness_min"];
            }
            if (state.popup_data["gamma_data"] && state.popup_data["gamma_data"].length > 0) {
              state.send["gamma"] = state.popup_data["gamma"];
            } else if (state.data["custom_settings"] && state.data["custom_settings"]["gamma"]) {
              state.send["gamma"] = state.data["custom_settings"]["gamma"];
            }
            // console.log('state.popup_data["temperature_data"]',state.popup_data["temperature_data"])
            // 判斷使用色溫還是座標
            var useColorTemperature = state.popup_data['whitePointSelect'] == 'colorTemperature';
            if (!state.popup_data['whitePointSelect'] && state.data["custom_settings"]) {
              // 如果 popup_data 沒有設定，根據原始資料判斷
              useColorTemperature = !state.data["custom_settings"]["color_x"] || !state.data["custom_settings"]["color_y"];
            }

            if (useColorTemperature) {
              if (state.popup_data["temperature_data"] && state.popup_data["temperature_data"].length > 0) {
                state.send["color_temperature"] = state.popup_data["temperature_start"] * 100;
              } else if (state.data["custom_settings"] && state.data["custom_settings"]["color_temperature"]) {
                state.send["color_temperature"] = state.data["custom_settings"]["color_temperature"];
              }
            } else {
              //coordinate
              if (state.popup_data["coordinate"]) {
                state.send["color_x"] = Number(state.popup_data["coordinate"]['x']);
                state.send["color_y"] = Number(state.popup_data["coordinate"]['y']);
              } else if (state.data["custom_settings"]) {
                state.send["color_x"] = state.data["custom_settings"]["color_x"];
                state.send["color_y"] = state.data["custom_settings"]["color_y"];
              }
              //coordinate
            }
            if (state.popup_data["EOTF"]) {
              state.send["eotf"] = state.popup_data["EOTF"]["val"];
            } else if (state.data["custom_settings"] && state.data["custom_settings"]["eotf"] !== undefined) {
              state.send["eotf"] = state.data["custom_settings"]["eotf"];
            }
            break
        }
        console.log('send modify', state.send)
        //#endregion


        await apiSetModify(state.send);
        state.applyDisable = false
        store.commit('setFlashMsg', { data: `${t('__flash.__modifiedAppointmentSuccessfully')}`, isShow: true })
        route.back();
      }
    }
    //#endregion
    //#region popup
    const store = useStore();
    const storeState = store.state;
    const schedule = ref();

    const onClickCheckCalibrator = () => {
      let isPresetModeLimit = state.send['preset_target'] ? onCheckPresetLimit() : false
      console.log('!!!!!', state.send, state.popup_data)
      if (state.calibrator['val'] == '4') { //spyderX 的校正器
        if ((router.name != "Modify Setting" && state.send['brightness'] > 650) || router.name == "Modify Setting" && state.popup_data['brightness_max'] > 650) {
          const modalConfig = {
            type: POPUP.BRIGHTLIMIT,
            data: '',
            isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
          return true
        } else if (state.send['preset_target'] && isPresetModeLimit && state.send['model'] != 'PA32DC') {
          //只有PA32DC不用擋, 因為 PA32DC 亮度 (HDR, Peak)：500 cd/㎡ 不會超過
          const modalConfig = {
            type: POPUP.PRESETLIMIT,
            data: '',
            isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
          return true
        } else {
          // console.log('CCC1')
          onClick()
        }
      } else {
        // console.log('CCC2')
        onClick()
      }
    }

    const onCheckPresetLimit = () => {
      let myData = []
      myData = state.send['preset_target'].filter((e) => {
        return state.presetLimitList.indexOf(e) > -1
      })
      return myData.length ? true : false
    }

    const changePresetHDR = () => { //preset HDR的模式 + spacex(spyder)矯正器  ==> 校正preset mode去除有HDR的
      let myData = []
      myData = state.send['preset_target'].filter((e) => {
        return state.presetLimitList.indexOf(e) === -1
      })
      state.send['preset_target'] = myData
    }

    const changeBrightLimit = () => { //亮度超過650 + spacex(spyder)矯正器 ==> 校正亮度為650
      if (router.name == FEATURENAME.MODIFY) {
        state.popup_data['brightness_max'] = 650
      } else {
        state.send['brightness'] = 650
      }
    }

    const onClick = () => { //moment?
      // console.log('schedule?????',schedule.value)

      let el = schedule.value;

      // ✅ 修正：使用 moment 物件而非字串，保留時區資訊
      let today = moment().add(10, 'minutes');

      let hour = state.hour.val.toString().length > 1 ? state.hour.val.toString() : `0${state.hour.val}`
      let second = state.second.val.toString().length > 1 ? state.second.val.toString() : `0${state.second.val}`

      let dd = moment(state.date2).format('YYYY.MM.DD')
      let chooseDay = `${dd} ${hour}:${second}`;
      let chooseUTC = parseInt(state.UTC.val)

      console.log('🔍 [Debug] state.UTC.val:', state.UTC.val);
      console.log('🔍 [Debug] chooseUTC:', chooseUTC);

      // ✅ 修正：正確解析指定時區的時間
      // 建立帶有時區資訊的時間字串，例如 "2026.01.26 14:00 -05:00" 或 "2026.01.26 14:00 +08:00"
      let sign = chooseUTC >= 0 ? '+' : '-';
      let absUTC = Math.abs(chooseUTC);
      let utcOffsetString = ` ${sign}${absUTC < 10 ? '0' : ''}${absUTC}:00`;

      console.log('🔍 [Debug] utcOffsetString:', utcOffsetString);
      console.log('🔍 [Debug] Full time string:', `${chooseDay}${utcOffsetString}`);

      let finalTime = moment.parseZone(`${chooseDay}${utcOffsetString}`, 'YYYY.MM.DD HH:mm Z');

      // 🔍 Debug log
      // console.log('⏰ [Time Validation] Current time + 10min:', today.format('YYYY-MM-DD HH:mm Z'));
      // console.log('⏰ [Time Validation] Selected time:', finalTime.format('YYYY-MM-DD HH:mm Z'));
      // console.log('⏰ [Time Validation] Selected time (local):', finalTime.local().format('YYYY-MM-DD HH:mm Z'));
      // console.log('⏰ [Time Validation] Is valid?', finalTime.isAfter(today));

      // console.log(finalTime,'??????',today)  //router.name != "Modify Setting"
      // console.log('router.name',router.name);
      if (state.selectedRepeat == "0") {
        // ✅ 修正：使用 moment 物件的 isBefore 方法比較，會自動處理時區轉換
        if (finalTime.isBefore(today)) {
          state.forbid = t('__a7d.__startTimeNeeds2HoursLater');
          el.scrollIntoView(true);
          window.scrollBy({
            top: -90,
            left: 0,
            behavior: "smooth"
          })
          return
        } else {
          state.forbid = ''
        }
      }
      console.log('click test console', state.rank["val"]);

      // console.log('這個apply', state.rank["val"]);
      var _day = state.rank["val"]
      if (state.selectedRepeat == "2" && (_day == 29 || _day == 30 || _day == 31)) {
        const modalConfig = {
          type: POPUP.SAVEMODIFY,
          data: {},
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      } else {
        state.applyDisable = true
        sendData()
      }
    }
    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.SAVEMODIFY) {
        console.log('toreState.modalBtnType', storeState.modalBtnType);
        // modal btn type
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput
          console.log(output);
          state.applyDisable = true
          sendData();
        }
      } //end: modal
    })
    const onClickSetting = () => {
      // console.log('storeState.modalOutput', state.popup_data['temperature'])
      // alert('click test console');
      // setLineBar();
      // let clonePopupData = { ...state.popup_data};
      let clonePopupData = JSON.parse(JSON.stringify(state.popup_data));
      console.log("!!!!!!!!!", clonePopupData)
      // console.log("型態", typeof state.popup_data['card'])
      const modalConfig = {
        type: POPUP.MODIFYSETTING,
        data: clonePopupData,
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }
    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.MODIFYSETTING) {
        console.log('toreState.modalBtnType', storeState.modalBtnType);
        // modal btn type
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          // console.log('output MODIFYSETTING', output);
          if (output["brightness_max"]) {
            output["brightness_max_start"] = output["brightness_max"];
          }
          if (output["brightness_min"]) {
            output["brightness_min_start"] = output["brightness_min"];
          }
          if (output["gamma"]) {
            output["gamma_start"] = output["gamma"];
          }
          if (output["temperature"]) {
            output["temperature_start"] = output["temperature"] / 100;
          }

          if (output['whitePointSelect'] == 'colorTemperature') { //colorTemperature 或 coordinate 要回復原樣
            output["coordinate"] = { x: state.coordinateEnum['x']['default'], y: state.coordinateEnum['y']['default'] }
          } else {
            let targetNow = output['target_op'][output['target_op'].map(x => x.val).indexOf(Number(output['target'].val))];
            if (targetNow || targetNow == 0) {
              console.log(targetNow['color_temperature'] / 100)
              output["temperature_start"] = targetNow['color_temperature'] / 100
            } else {//套用 cloud target 的模式的時候，temperature default 4000
              // output["temperature_start"] = 40
            }
          }
          // 
          state.popup_data = output;
          console.log("state.popup_data", state.popup_data);
        }
      } else if (oldType === POPUP.LEAVEADVANCED) {
        console.log('LEAVEADVANCED')
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          output.goNext()
        }
      } else if (oldType === POPUP.BRIGHTLIMIT) {
        console.log('BRIGHTLIMIT')
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          changeBrightLimit()
          onClick()
        }
      } else if (oldType === POPUP.PRESETLIMIT) {
        console.log('PRESETLIMIT')
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          changePresetHDR()
          onClick()
        }
      }

      //end: modal
    })
    //#endregion
    //#region watch

    // watch( //有內建校正器的機台在設定校正時(有Embedded), 選擇外接校正器後(不選Embedded), 應預設勾選當外接不能用時以內建代替(下面checkbox要打勾)
    //   () => state.calibrator,
    //   (v) => {
    //     if(router.name === FEATURENAME.ADVANCED){
    //       let hasEmbedded = state.calibrator_op.map((e) => { return e.text }).indexOf('Embedded');
    //       console.log('has Embedded ?', hasEmbedded)
    //       if (hasEmbedded > -1) {
    //       //Embedded val 是 0
    //         state.iscalibrator_embedded = v.val == '0' ? false : true
    //       }
    //     }//end: if 

    //   },
    //   { deep: true }
    // )
    //有內建校正器的機台在設定校正時(有Embedded), 選擇外接校正器後(不選Embedded), 應預設勾選當外接不能用時以內建代替(下面checkbox要打勾)
    let onChangeCalibrator = (val) => {
      console.log('onChangeCalibrator', val);

      //Embedded val 是 0
      state.iscalibrator_embedded = val.val == 0 ? false : true
      console.log('onChangeCalibrator iscalibrator_embedded', state.iscalibrator_embedded);

    }


    watch( //Single或Weekly Repeat，"Postpone to next working day then schedule on weekend"不能做勾選
      () => state.selectedRepeat,
      (v) => {
        if (v == '0') {  //只有選single要被禁止
          setDateForbid()
          resetWeek()
          resetMonth()
        } else {
          state.dateForbid2 = null
          if (v == '1') {
            resetMonth()
          } else {
            resetWeek()
          }
        }
        state.work_day = v == '2' ? state.work_day : false

      },
    )

    watch(
      () => state.date2,
      (v) => {
        state.applyDisable = (v == '' || v === null) ? true : false;
      },
    )

    const resetWeek = () => {
      state.week = state.week_op[0]
      state.day = state.day_op[0]
    }

    const resetMonth = () => {
      state.month = state.month_op[0]
      state.rank = state.rank_op[0]
    }


    const isCheckChange = () => { //checkbox有radio單選屬性改掉了，不用了，但先留著
      // console.log('isCheckChange',v)
      // state.isCheck_Array.forEach(element => {
      //   element.isCheck = false;
      // });
      // state.isCheck_Array[v].isCheck = true;
    }

    watch( //設定校正時選擇No assitional reminder, Additional reminder不可做勾選且要清空
      () => state.selectedReminder,
      (v) => {
        let isNoReminder = v == '0' ? true : false
        if (state.isCheck_Array) {
          console.log('state.isCheck_Array', state.isCheck_Array)
          for (let i = 0; i < state.isCheck_Array.length; i++) {
            if (isNoReminder) {
              state.isCheck_Array[i]['isCheck'] = false;
            }
          }
        }
      },
    )

    // ✅ 新增：監聽時區變化，動態更新可選日期範圍
    watch(
      () => state.UTC,
      () => {
        console.log('🔄 [Watch] UTC timezone changed, updating date range...');
        updateDateForbidByTimezone();
      },
      { deep: true }
    )

    //上一頁存資料
    watch(
      () => route,
      (to) => {
        if (to.currentRoute.value.name == FEATURENAME.CALIBRATION) {
          let save = {
            calibrator: state.calibrator,
            embedded: state.iscalibrator_embedded,
            warmUp: state.selectedWarmUp,
            date: state.date2,
            utc: state.UTC,
            hour: state.hour,
            second: state.second,
            selectedRepeat: state.selectedRepeat,
            week: state.week,
            day: state.day,
            month: state.month,
            rank: state.rank,
            workDay: state.work_day,
            selectedAfter: state.selectedAfter,
            selectedReminder: state.selectedReminder,
            isCheck: state.isCheck_Array,
          }
          store.commit('setAdvanceData', save);
          console.log('##$$$$', save)
          //#endregion
        }


      },
      { deep: true }
    )






    //#endregion
    return {
      state,
      iconSrc,
      onClick,
      onClickSetting,
      IsChecked,
      second_op,
      hour_op,
      week_op,
      month_op,
      rank_op,
      timeInit,
      setDateForbid,
      isCheckChange,
      timeZoneInit,
      schedule,
      setSaveData,
      resetMonth,
      resetWeek,
      t,
      isCheckArray,
      orgDicomOP,
      onClickCheckCalibrator,
      changeDatePicker,
      onCheckPresetLimit,
      changePresetHDR,
      onChangeCalibrator
    }
  }
}


